import React from 'react';
import { TypographyH3, TypographyP } from '@/Components/shadcn';

export interface ProfileGroupFormProps {
    dataCy?: string;
    title: string;
    description: string;
    width?: string;
}

export default function ProfileGroupForm({
    dataCy,
    title,
    description,
    width,
    children,
}: React.PropsWithChildren<ProfileGroupFormProps>): React.JSX.Element {
    return (
        <div data-cy={dataCy} className="flex flex-col gap-2" style={{ width }}>
            <TypographyH3>{title}</TypographyH3>
            <TypographyP>{description}</TypographyP>
            {children}
        </div>
    );
}
